module.exports = __webpack_public_path__ + "static/img/WB800-PF_A.8e48646.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/WB800-PF_A.jpg
// module id = jhHl
// module chunks = 0